import BaseService from '_services/rest/base';

class DashboardService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/dashboard`;
  }

  getQuotationsDashboardAlerts(params) {
    return this.request(`${this.getUrl()}/alerts/${params.skip}/${params.take}`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getTicketsStats() {
    return this.request(`${this.getUrl()}/ticketsStats`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getStatsDashboard() {
    return this.request(`${this.getUrl()}/stats`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getNotificationsAlerts() {
    return this.request(`${this.getUrl()}/alerts/unread/`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  setReadNotification(quotationId) {
    return this.request(`${this.getUrl()}/alerts/read/${quotationId}`)
      .catch(err => {
        throw err;
      });
  }
}

export default new DashboardService();
